export default {
  "BANNED": "banned",
  "EMAIL_ALREADY_EXISTS": "email_already_exists",
  "EMAIL_DOES_NOT_EXIST": "email_does_not_exist",
  "FORBIDDEN": "forbidden",
  "INFRASTRUCTURE_DOWN": "infrastructure_down",
  "LOGIN_FAILED": "login_failed",
  "ACCOUNT_LOCKED": "account_lockout",
  "NOT_FOUND": "not_found",
  "OTHER_EXTERNAL": "other_external",
  "OTHER_INTERNAL": "other_internal",
  "UNAUTHENTICATED": "unauthenticated",
  "INVALID_MIGRATION_PASSWORD": "invalid-migration-password",
  // NOTE: code-mismatch is passed from loopback and an error name and not error code.
  // error code for code-mismatch is 'forbidden'.
  // We require this because we want to print a friendlier error message for code-mismatch.
  "CODE_MISMATCH": "code-mismatch",
  "MFA_CODE_INVALID": "mfa_code_invalid"
};
